import callMade from "Assets/icons/enviroment/call_made.svg";
import { useNavigate } from "react-router-dom";

import "./CardLink.scss";
import { trackEvent } from "Services/Analytics/trackEvent";

interface EnviromentCardProps {
  title: string;
  img: string;
  background: "green" | "sky" | "blue";
  navigateTo?: string;
  elementId?: string;
  eventName: string;
}

const CardLink = ({
  title,
  img,
  background,
  navigateTo,
  elementId,
  eventName,
}: EnviromentCardProps) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    trackEvent(eventName);
    if (!navigateTo) return;

    const isExternal = navigateTo.startsWith("http");

    if (isExternal) {
      window.open(navigateTo, "_blank");
    } else {
      const currentPath = window.location.pathname;

      if (currentPath === navigateTo && elementId) {
        // Ya estás en la misma página, hacé el scroll directamente
        const el = document.getElementById(elementId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navegá normalmente y que la otra vista se encargue de hacer el scroll
        navigate(navigateTo, {
          state: { scrollToId: elementId },
        });
      }
    }
  };

  return (
    <article className={`cardLink bg-${background}`} onClick={handleNavigate}>
      <header className="cardLink-header">
        <img
          width={144}
          height={144}
          className="cardLink-icon"
          loading="lazy"
          src={img}
          alt={title}
        />
        <img
          className="call"
          width={16}
          height={16}
          src={callMade}
          alt="call made"
        />
      </header>
      <p className="cardLink-text">{title}</p>
    </article>
  );
};

export default CardLink;
